<!--Navbar-->
<mdb-navbar SideClass="navbar navbar-expand-lg    scrolling-navbar navbar-light"  style="Z: INDEX 20000px !important;">

        <!-- Navbar brand -->
        <mdb-navbar-brand><a class="navbar-brand" routerLink="/">eo ipso</a></mdb-navbar-brand>
    
        <!-- Collapsible content -->
        <links style="justify-content:flex-end">
    
            <!-- Links -->
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
 
                <li class="nav-item">
                        <a class="nav-link waves-light" routerLink='/leistungsangebot' mdbWavesEffect>Leistungsangebot</a>
                </li>

                <li class="nav-item">
                        <a class="nav-link waves-light" routerLink='/methoden' mdbWavesEffect>Methoden</a>
                </li>
         
                <li class="nav-item">
                        <a class="nav-link waves-light" routerLink='/konzept'  mdbWavesEffect>Konzept</a>
                </li>
                
                <!--                <li class="nav-item">
                        <a class="nav-link waves-light" mdbWavesEffect>Vernetzung</a>
                </li>
                    -->

                    
                <li class="nav-item dropdown" dropdown>
                    <a dropdownToggle mdbWavesEffect type="button" class="nav-link dropdown-toggle waves-light" mdbWavesEffect>

                        
                    Verschiedenes<span class="caret"></span></a>
                    <div *dropdownMenu class="dropdown-menu dropdown dropdown-primary" role="menu">
                        <a class="dropdown-item waves-light"  routerLink="/impressum" mdbWavesEffect href="#">Impressum</a>
                        <a class="dropdown-item waves-light"  routerLink="/datenschutz" mdbWavesEffect href="#">Datenschutz</a>
                    </div>
                </li>
   
            </ul>
            <!-- Links -->
    
 
        </links>
        <!-- Collapsible content -->
    
    </mdb-navbar>
    <!--/.Navbar-->